import React from "react"
import { useNoteContext } from "./note-context"
import { cva } from "class-variance-authority"
import { cn } from "../utils"

// =============================================================================
// Styles
// =============================================================================

const contentStyles = cva(
  "[grid-area:content] flex flex-col text-sm leading-6",
  {
    variants: {
      layout: {
        horizontal: "",
        stacked: "",
        inline: [
          "flex-1 min-w-[min(var(--note-content-min-width),100%)] block wrap-break-word",
          // Progressively enhance when calc-size() is supported by taking the min of the content size compared to the default min width
          "supports-[min-width:calc-size(max-content,size)]:min-w-[calc-size(max-content,min(size,var(--note-content-min-width),100%))]",
          "[&>[data-slot=note-heading]]:inline [&>[data-slot=note-heading]]:mr-1 [&>[data-slot=note-heading]+*]:inline"
        ]
      }
    }
  }
)

// =============================================================================
// Props
// =============================================================================
export type NoteContentProps = {
  children: React.ReactNode
  className?: string
}

export function NoteContent({ children, className }: NoteContentProps) {
  const { layout } = useNoteContext()
  return (
    <div
      className={cn(contentStyles({ layout }), className)}
      data-slot="note-content"
    >
      {children}
    </div>
  )
}
